module.exports = __webpack_public_path__ + "static/media/W05F0001N0000.159d6ff1.svg";